<template>
  <div class="footer">
    <div class="footerbar" id="bottom">
      <div class="footerbar-item has-text-centered">
        <img src="~@/assets/footer_logo.png" class="logo" alt="The Home Depot Pro - A Home Depot Company">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterBar'
}
</script>



// WEBPACK FOOTER //
// src/components/FooterLogo.vue